export const GET_JD_FROM_ATS_REQUEST="GET_JD_FROM_ATS_REQUEST";
export const GET_JD_FROM_ATS_SUCCESS="GET_JD_FROM_ATS_SUCCESS";
export const GET_JD_FROM_ATS_FAILURE="GET_JD_FROM_ATS_FAILURE";